/**
 * Backfill — icons the app renders but nobody registered.
 *
 * FontAwesome's lookup misses silently: an unregistered pair draws no glyph,
 * throws nothing, logs nothing. The row still lays out, so the space reserved
 * for the icon just sits there empty and the screen reads as broken.
 *
 * Every icon below was found by src/icons/__tests__/iconRegistryCoverage —
 * each one was already being rendered somewhere in src/, and each one was
 * drawing nothing. They exist in the installed Pro packages; they had simply
 * never been added to the library. The most visible casualty was the Library's
 * suggested-document rows (#2234), built around ['fad','file-circle-plus'] —
 * every suggestion showed an empty dashed box.
 *
 * They are grouped here because that is what they have in common: provenance,
 * not domain. A NEW icon should go in the matching domain file
 * (core / ai / messaging / users / admin / …), not here — this module is the
 * record of a gap that has now been closed and guarded.
 */

import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faBellExclamation,
  faBookOpen,
  faCircleNotch,
  faCircleSmall,
  faCommentCheck,
  faCommentLines,
  faFileAudio,
  faFileVideo,
  faFileZipper,
  faFolderTree,
  faPaperclip,
  faPauseCircle,
  faPenRuler,
  faPhone,
  faSitemap,
  faToggleOn,
  faUserMinus,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faCircleMinus as fasCircleMinus,
  faCode as fasCode,
  faCreditCard as fasCreditCard,
  faCube as fasCube,
  faDesktop as fasDesktop,
  faEnvelope as fasEnvelope,
  faHome as fasHome,
  faMagicWandSparkles as fasMagicWandSparkles,
  faMobile as fasMobile,
  faPlug as fasPlug,
  faScrewdriverWrench as fasScrewdriverWrench,
  faSliders as fasSliders,
  faTag as fasTag,
  faWandMagicSparkles as fasWandMagicSparkles,
  faWaveSquare as fasWaveSquare,
} from '@fortawesome/pro-solid-svg-icons';

export function loadBackfillIcons(): void {
  library.add(
    faBellExclamation,
    faBookOpen,
    faCircleNotch,
    faCircleSmall,
    faCommentCheck,
    faCommentLines,
    faFileAudio,
    faFileVideo,
    faFileZipper,
    faFolderTree,
    faPaperclip,
    faPauseCircle,
    faPenRuler,
    faPhone,
    faSitemap,
    faToggleOn,
    faUserMinus,
    fasCircleMinus,
    fasCode,
    fasCreditCard,
    fasCube,
    fasDesktop,
    fasEnvelope,
    fasHome,
    fasMagicWandSparkles,
    fasMobile,
    fasPlug,
    fasScrewdriverWrench,
    fasSliders,
    fasTag,
    fasWandMagicSparkles,
    fasWaveSquare,
  );
}

export default loadBackfillIcons;
